import useMaps from '../hooks/useMaps';
import { MapType } from '../CommonTypes';

export const MapSceneSelect = ({
  currentScene,
  setSelectedScene,
}: {
  currentScene: MapType;
  setSelectedScene: (map: MapType) => void;
}) => {
  const [maps] = useMaps();

  return (
    <div className="z-2 absolute left-0 top-10 flex flex-col gap-2">
      {maps.map((map, index) => {
        const isActive = currentScene?.mapid === map.mapid;
        return (
          <button
            key={`scene-button-${index}`}
            onClick={() => setSelectedScene(map)}
            className={`rounded-r-md px-2 py-1 text-xs text-white transition hover:scale-105 md:px-4 md:py-2 md:text-sm ${
              isActive ? 'ml-[3px] scale-105 bg-[#00965f]/80 font-bold shadow-lg' : 'bg-black bg-opacity-50'
            }`}
          >
            {map.name ?? `Scen ${index + 1}`}
          </button>
        );
      })}
    </div>
  );
};
